module.exports = __webpack_public_path__ + "static/media/12-rectangle-onhold.cf4a4fff.svg";